import createReactComponent from '../createReactComponent';
export default createReactComponent('registered', 'IconRegistered', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 15v-6h2a2 2 0 1 1 0 4h-2', key: 'svg-1' }],
  ['path', { d: 'M14 15l-2 -2', key: 'svg-2' }],
]);
